import { raundUrl, urlusersheets } from '@/lib/custom'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

export const fetchAsyncGetCampaign = createAsyncThunk('campaign/getData', async () => {
  let result: { campaign: Api.CampaignResBody }
  try {
    const res = await fetch(raundUrl.campaign, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
        'X-Local': localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}_i18nextLng`),
      },
    })

    result = await res.json()

    localStorage.setItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-clientid`, result.campaign.cognitoClientId)
  } catch (e) {
    throw new Error('Whoops!')
  }

  return {
    campaign: result.campaign,
  }
})

export const fetchAsyncGetUserSheets = createAsyncThunk('sheets/getData', async () => {
  let result: { sheets: Api.SheetObject[] }
  const JWT = await localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`)

  try {
    const res = await fetch(`${urlusersheets}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
        'X-Authorization': JWT,
        'X-Local': localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}_i18nextLng`),
      },
    })

    result = await res.json()
  } catch (e) {
    throw new Error('Whoops!')
  }

  return {
    sheets: result.sheets,
  }
})

type initialProps = {
  campaign: Api.CampaignResBody
  sheets: Api.SheetObject[]
}

const initialState: initialProps = {
  campaign: {
    campaignStartAt: '',
    campaignEndAt: '',
    viewStartAt: '',
    viewEndAt: '',
    cognitoClientId: '',
    cognitoClientSecret: null,
    cognitoIdentityProvider: null,
    isLineLogin: false,
    description: '',
    type: null,
    defaultSheet: null,
    defaultSheetId: null,
    isRepeatStamp: false,
    isRepeatStampWeekly: false,
    exchangeEndAt: '',
    exchangeStartAt: '',
    id: 1,
    image: '',
    loginType: 1,
    lotteryImage: null,
    postPhoto: 0,
    name: '',
    title: '',
    period: true,
    playingEndAt: '',
    playingStartAt: '',
    outOfTermMessage: '',
    timestamp: '',
    listType: null,
    maps: null,
    usage: null,
    isQRCodeWithGPS: null,
    isKeywordWithGPS: null,
    isDisplayCampaignName: null,
    isDisplayEventPeriod: null,
    mapCaption: '',
    map_pin: '',
    center: { latitude: 0, longitude: 0 },
    presentDetailFileCaption: '',
    postPhotoIsNickname: null,
    postPhotoNicknameCaption: '',
    postPhotoIsPlace: null,
    postPhotoPlaceCaption: '',
    stampPopup: {
      icons: [],
      message: null,
    },
    isLocalize: false,
    languages: [],
    popup: null,
    ad: false,
    adKey: null,
    adRedirectUrl: null,
    adRedirectExpire: null,
  },
  sheets: [
    {
      description: '',
      earnedPoints: 0,
      id: 'all',
      startAt: '',
      endAt: '',
      name: '',
      spots: [
        {
          address: '',
          description: '',
          id: 1,
          image: '',
          image2: '',
          image3: '',
          image4: '',
          image5: '',
          image6: '',
          image7: '',
          image8: '',
          isCoupon: false,
          isStamp: true,
          latitude: 1,
          longitude: 1,
          name: '',
          displayNumber: 0,
          stamp: {
            id: 1,
            image: '',
            isHas: false,
            name: '',
            period: false,
            range: 1,
            point: 0,
            earnedPoints: 0,
            stampCount: 0,
            type: 0,
            startAt: '',
            endAt: '',
          },
        },
      ],
    },
  ],
}

const AsyncThunkSlice = createSlice({
  name: 'async',
  initialState: initialState,
  reducers: {
    fetchCampaign(state, action) {
      state.campaign = action.payload
    },
    fetchSheets(state, action) {
      state.sheets = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAsyncGetCampaign.fulfilled, (state, action) => {
      return {
        ...state,
        campaign: action.payload.campaign,
      }
    })
    builder.addCase(fetchAsyncGetCampaign.rejected, (state, action) => {
      console.log({ state })
      console.log({ action })
    })
    builder.addCase(fetchAsyncGetUserSheets.fulfilled, (state, action) => {
      return {
        ...state,
        sheets: action.payload.sheets,
      }
    })
    builder.addCase(fetchAsyncGetUserSheets.rejected, (state, action) => {
      console.log({ state })
      console.log({ action })
    })
  },
})

export const { fetchCampaign } = AsyncThunkSlice.actions

export default AsyncThunkSlice.reducer
